import { Order } from "../model/order";
import { OrderEntry } from "../model/order-entry";
import { Cart } from "api/model/mini-cart";

type EntryToBeAdded = { code: string; quantity: number; deliveryDate?: string };

/**
 * @author kcr8wz
 * @date 2019-09
 * @licensor Robert Bosch GmbH, 2018
 * @version 1.0.0
 *
 * @jsdoc request
 * @name api.requests:AddToCartRequest
 * @description
 * Add to cart request representing request body object
 */
export class AddToCartRequest {
  cart: Cart;
  order: Order;
  preventEntriesMerge: boolean;

  constructor(
    cart: Cart,
    entries: Array<EntryToBeAdded>,
    preventEntriesMerge = false
  ) {
    const orderEntries = entries.map(
      ({ code, quantity }) =>
        ({
          product: { code },
          quantity,
          preventEntriesMerge: preventEntriesMerge,
        } as OrderEntry)
    );
    this.order = { orderEntries };
    this.cart = cart;
  }
}
